import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useRecoilCallback } from 'recoil';
import { Box, Button, CircularProgress, Grid, TextField } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { resetPasswordRequest } from './../../Recoil/Selectors/Auth'

import { marginStyles } from '../../Common/Styles/Margins';

const RequestResetPasswordForm = (params: any) => {
  const marginClasses = marginStyles();
  const [alert, setAlert] = useState(null);
  const onSubmit = useRecoilCallback(({snapshot}) => async (values: any) => {
    const { result, success } = await snapshot.getPromise(resetPasswordRequest({ Contact_Email: values.Contact_Email }));
    if (success) {
      setAlert({ message: result.message, status: 'success' })
    } else {
      setAlert({ message: 'Failed to Reset Password', status: 'error' })
    }
  })
  const validation = Yup.object().shape({
    Contact_Email: Yup.string().email('Invalid Email').required('Please Enter Your Email'),
  })

  return (
    <Formik
      initialValues={{ Contact_Email: '' }}
      validationSchema={validation}
      onSubmit={onSubmit}
    >
      {({
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        touched,
        values,
        errors,
      }) => (
        <form onSubmit={handleSubmit}>
          <Grid item xs={12}>
            <TextField
              label='Email'
              name='Contact_Email'
              variant='outlined'
              size='small'
              fullWidth
              value={values.Contact_Email}
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={touched.Contact_Email && errors.Contact_Email}
              error={Boolean(touched.Contact_Email && errors.Contact_Email)}
            />
          </Grid>
          { alert &&
            <Box my={2}>
              <Alert severity={alert.status}>{alert.message}</Alert>
            </Box>
          }
          <Box display='flex' justifyContent='flex-end' mt={3}>
            <Link to='/login'>
              <Button className={marginClasses.mr1} color='primary' size='small'>
                Back to login
              </Button>
            </Link>
            <Button
              type='submit'
              color='primary'
              variant='contained'
              size='small'
              disabled={isSubmitting}
            >
              {isSubmitting && <CircularProgress className={marginClasses.mr2} color='inherit' size={25} />}
              Submit
            </Button>
          </Box>
        </form>
      )}
    </Formik>
  );
};

export { RequestResetPasswordForm };
